const FETCHING_ALL_COURSES = "FETCHING_ALL_COURSES"
const FETCHING_ALL_COURSES_FAILURE = "FETCHING_ALL_COURSES_FAILURE"
const FETCHING_ALL_COURSES_SUCCESS = "FETCHING_ALL_COURSES_SUCCESS"

const ADDING_COURSE = "ADDING_COURSE"
const ADDING_COURSE_FAILURE = "ADDING_COURSE_FAILURE"
const ADDING_COURSE_SUCCESS = "ADDING_COURSE_SUCCESS"

const DELETING_COURSE = "DELETING_COURSE"
const DELETING_COURSE_FAILURE = "DELETING_COURSE_FAILURE"
const DELETING_COURSE_SUCCESS = "DELETING_COURSE_SUCCESS"

const UPDATING_COURSE = "UPDATING_COURSE"
const UPDATING_COURSE_FAILURE = "UPDATING_COURSE_FAILURE"
const UPDATING_COURSE_SUCCESS = "UPDATING_COURSE_SUCCESS"

export function addingCourse() {
  return {
    type: ADDING_COURSE
  }
}

export function addingCourseFailure(error) {
  return {
    type: ADDING_COURSE_FAILURE,
    error
  }
}

export function addingCourseSuccess(courses) {
  return {
    type: ADDING_COURSE_SUCCESS,
    courses,
    error: ""
  }
}
export function updatingCourse() {
  return {
    type: UPDATING_COURSE
  }
}

export function updatingCourseFailure(error) {
  return {
    type: UPDATING_COURSE_FAILURE,
    error
  }
}

export function updatingCourseSuccess(courses) {
  return {
    type: UPDATING_COURSE_SUCCESS,
    courses,
    error: ""
  }
}

export function deletingCourse() {
  return {
    type: DELETING_COURSE
  }
}

export function deletingCourseFailure(error) {
  return {
    type: DELETING_COURSE_FAILURE,
    error
  }
}

export function deletingCourseSuccess(courses) {
  return {
    type: DELETING_COURSE_SUCCESS,
    courses,
    error: ""
  }
}

export function fetchingAllCourses() {
  return {
    type: FETCHING_ALL_COURSES
  }
}

export function fetchingAllCoursesFailure(error) {
  return {
    type: FETCHING_ALL_COURSES_FAILURE,
    error
  }
}

export function fetchingAllCoursesSuccess(courses) {
  return {
    type: FETCHING_ALL_COURSES_SUCCESS,
    courses,
    error: ""
  }
}
const initialState = {
  courses: null,
  courseId: null,
  isFetching: false,
  error: ""
}

export function manageCourses(state = initialState, action) {
  switch (action.type) {
    case ADDING_COURSE:
      return {
        ...state,
        isFetching: true,
        error: ""
      }
    case ADDING_COURSE_FAILURE:
      return {
        ...state,
        error: action.error,
        isFetching: false
      }
    case ADDING_COURSE_SUCCESS:
      return {
        ...state,
        error: "",
        isFetching: false,
        courses: action.courses
      }
    case DELETING_COURSE:
      return {
        ...state,
        isFetching: true,
        error: ""
      }
    case DELETING_COURSE_FAILURE:
      return {
        ...state,
        error: action.error,
        isFetching: false
      }
    case DELETING_COURSE_SUCCESS:
      return {
        ...state,
        error: "",
        isFetching: false,
        courses: action.courses
      }
    case UPDATING_COURSE:
      return {
        ...state,
        isFetching: true,
        error: ""
      }
    case UPDATING_COURSE_FAILURE:
      return {
        ...state,
        error: action.error,
        isFetching: false
      }
    case UPDATING_COURSE_SUCCESS:
      return {
        ...state,
        error: "",
        isFetching: false,
        courses: action.courses
      }

    case FETCHING_ALL_COURSES:
      return {
        ...state,
        error: "",
        isFetching: true
      }
    case FETCHING_ALL_COURSES_FAILURE:
      return {
        ...state,
        isFetching: false
      }
    case FETCHING_ALL_COURSES_SUCCESS:
      return {
        ...state,
        error: "",
        isFetching: false,
        courses: action.courses,
        courseId: ""
      }
    default:
      return state
  }
}
